import React, { useContext } from "react";
import { t } from "ttag";

import { ReactivatedContext as Context } from "../../context";
import { Select, SelectItem } from "../Forms/Select";

export const StateSelect = ({
    className,
    name = "state",
}: {
    className?: string;
    name?: string;
}) => {
    const context = useContext(Context);

    return (
        <Select
            label={t`State`}
            name={name}
            isRequired
            placeholder={t`Select a state`}
            className={className}
        >
            {Object.entries(context.STATES).map(([code, name]) => (
                /* eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any */
                <SelectItem key={code} id={code} value={code as any}>
                    {name}
                </SelectItem>
            ))}
        </Select>
    );
};
